import { BaseModel } from './base-model';
import { Picture } from './picture';

export class NewsModel extends BaseModel {
  titleFr: string;
  titleEn: string;
  descriptionFr: string;
  descriptionEn: string;

  picture: Picture;
}
